import Menu from '@/components/common/menu'
export default {
  name: 'Main',
  components: { //局部注册导航菜单组件
    Menu
  },
  data() {
    return {
      menu_list: [],
      user_name: '',
      show: false,
      houseList: [],
      warehouse_id: '',
      login_type: 0, //0是账户登录， 1 是子账户登录
      clicent_list: [{
        client_code: ' ',
        user_name: '全部'
      }], //客户列表
      clicent_list2: [{
        client_code: '',
        user_name: '全部'
      }], //客户列表
      client_code: ''
    }
  },
  inject: ['reload'],
  methods: {
    refresh() { //刷新页面
        this.reload();
    },
    clientChange(e) {
      this.client_code = e.value;
      localStorage.setItem('client_code', this.client_code)
      localStorage.setItem('client_name_code', e.label)
      // window.location.reload()
      this.refresh()
    },
    searchClientCode(value) {
      if(!value) return;
      this.clicent_list2 = [];
      var reg = new RegExp(value.toUpperCase());
      this.clicent_list.forEach(item => {
        if (reg.test(item.client_code.toUpperCase())) {
          if (this.clicent_list2.length < 10)
            this.clicent_list2.push(item);
        }
      });
    },
    houseChange(e) {
      this.warehouse_id = e;
      localStorage.setItem('warehouse_id', e)
      // window.location.reload()
      this.refresh()
    },
    init() {
      this.getMenu();
      this.getUserInfo()
      this.getHouseList()
    },
    getHouseList() { //仓库列表
      this.$axios.get("/warehouse/list").then(res => {
        if (res.success && res.data && res.data.length > 0) {
          this.houseList = res.data;
        } else {
          this.houseList = []
        }
      });
    },
    toggleShow() {
      this.show = !this.show
    },
    getMenu() {
      this.$axios.get('/static/js/menu.json', {
        baseURL: "./",
        headers: {
          noShowError: true
        }
      }).then(res => {
        if (res && res.length > 0) {
          if (this.login_type == 1) {
            this.menu_list = res.filter(item => {
              return item.function_name != '子账户管理'
            })
          } else {
            this.menu_list = res;
          }
        }
        this.getBiztype()
      });
    },
    getBiztype(){ //业务类型
      let arr = [];
      let list = [...this.menu_list]
      this.$axios.get("/client/biz/type").then(res => {
        if (res.success && res.data && res.data.length > 0) {
          let biz_types = res.data.map(v=>v.biz_type)
          console.log('biz_types----',biz_types)
          list.forEach(v=>{
            if(v.biz_type<0){
              arr.push(v)
            }
            if(biz_types.includes(v.biz_type)){
              arr.push(v)
            }
          })
          this.menu_list = arr;
        }else{
          this.menu_list = list.filter(v=>v.biz_type<0)
        }
      });
    },
    getRoleFun(id) {
      this.$axios.get("/role/function", {
        params: {
          role_id: id
        }
      }).then((data) => {
        if (data.success && data.data) {
          this.menu_list = data.data.sort(this.compareAscSort("orders"));
        } else {
          this.$Message.error(data.msg);
        }
      })
    },
    getUserInfo() { //获取登录用户信息
      this.$axios.get('/client/info').then(res => {
        if (res.success && res.data) {
          this.user_name = res.data.name;
          localStorage.setItem('client_id', res.data.client_id)
          localStorage.setItem('user_info', JSON.stringify(res.data))
          if (this.login_type == 0) {
            this.getClient()
          }
        }
      })
    },
    getClient(user_name) { //获取账户列表
      this.$axios.get("/client/code", {
        params: {
          pageNum: 1,
          pageSize: 10000,
        }
      }).then((data) => {
        if (data.success && data.data && data.data.length) {
          this.clicent_list = this.clicent_list.concat(data.data);
          this.searchClientCode(this.client_code);
        }
      })
    },
    sysOut() { //退出系统功能
      localStorage.setItem('token', '')
      this.$router.replace({
        path: "/Login"
      });
    },
    compareAscSort(property) { //属性排序
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      }
    }

  },
  created() {

    if (this.$route.query.token) {
      let token = window.atob(this.$route.query.token);
      this.$axios.defaults.headers.token = token;
      localStorage.setItem('token',token)
      localStorage.setItem('login_type',0)
      localStorage.removeItem('client_code')
      localStorage.removeItem('client_name_code')
      this.$router.replace({
        path:'/Home'
      })
    }
    this.login_type = localStorage.getItem('login_type')
    this.warehouse_id = localStorage.getItem('warehouse_id')
    this.client_code = localStorage.getItem('client_code')

  },
  mounted(){
    this.$nextTick(function(){
      this.init();
    })
  },
  watch: {
    $route() {
      let arr = this.$route.matched.filter(v => v.meta.title)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/layout/main.js